import NavLinkGroup from '../../app/components/main-menu/components/nav-link-group/NavLinkGroup';
import NavLink from '../../app/components/main-menu/components/NavLink';
import UrlsService from '../../../common/router/services/urlsService.mdl';
import useSessionManager from '../../session/hooks/useSessionManager';
import {observer} from 'mobx-react';

export default observer(function DashboardsLinks(): React.JSX.Element {
    const session = useSessionManager();

    return (
        <NavLinkGroup to={UrlsService.dashboards()} label="Dashboards" iconName="icon-dashboard-2">
            <NavLink to={UrlsService.dashboards()}>Dashboards List</NavLink>
            {session.isUserAllowed('create:dashboard') && <NavLink to={UrlsService.createDashboard()}>Create Dashboard</NavLink>}
        </NavLinkGroup>
    );
});
